export function initPageEntrance() {
    const appearObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('can-appear');
            }
        });
    }, {threshold: 0.1});

    document.querySelectorAll('.appear-observer').forEach(el => {
        let animationDelay = 0;
        el.querySelectorAll('[class*="fade-"]').forEach(childEl => {
            childEl.style.animationDelay = `${animationDelay}s`;
            animationDelay += .2;
        });
        appearObserver.observe(el);
    });
}